import FoodCard from './FoodCard';

function RecommendationList({ recommendations }) {
  if (!recommendations || recommendations.length === 0) {
    return null;
  }

  return (
    <div className="grid md:grid-cols-3 gap-4">
      {recommendations.map((food, index) => (
        <FoodCard key={index} food={food} />
      ))}
    </div>
  );
}

export default RecommendationList;
